module.exports = __webpack_public_path__ + "static/pop1-5aa3be439a485adbde9da51175146889.jpg";